import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";
import { BankAccountInterface } from "../../Entity/Entities/BankAccount/BankAccountInterface";

class PaymentsWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    this.component.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
    });

    const filter = this.component.props.app.financePaymentsFilterState;
    const filterDate = this.component.props.app.financePaymentsFilterDateState;
    const searchFilter = this.component.props.app.financePaymentsFilterSearchState;
    
    let selectedFilterBankAccount = this.component.props.app.financePaymentsFilterBankAccountState;
    if (!selectedFilterBankAccount) {
      const agencyBankAccount: BankAccountInterface = this.component.getAgencyBankAccounts()
                                .find((bankAccount: BankAccountInterface) => bankAccount.isDefault);
      if (!!agencyBankAccount) {
        selectedFilterBankAccount = String(agencyBankAccount.id);
      } else {
        selectedFilterBankAccount = "all";
      }
    }

    this.component.paginatorPath = `Finance_Payments_${filter}_${selectedFilterBankAccount}_${filterDate}_${searchFilter}`;
    if (this.component.props?.location?.query?.result) {

    }

    this.component.setState({
      filter: filter,
      agencyBankAccountId: selectedFilterBankAccount,
      filterValue: searchFilter,
      isPaymentUlinkPopupOpen: false,
      isPaymentRemovePopupOpen: false,
      isSaving: false,
      paymentDelete: null,
      isPaymentCheckToSettle: false,
      isPaymentUnSettlePopupOpen: false,
      unSettlePayment: null,
      dateFilter: filterDate,
      pontoConnectionDialogFromParams: this.component.props?.location?.query?.result ? true : false,
      pontoConnectionDialogMessageFromParams: this.component.props?.location?.query?.result || ""
    }, () => {
      this.component.fetchFirstAllPayments(() => {
        window.scrollTo({
          top: this.component.props.app?.financePaymentsListPosition
        });
      });
      this.component.fetchFirstUnusedPayments(() => {
        window.scrollTo({
          top: this.component.props.app?.financePaymentsListPosition
        });
      });
      this.component.fetchFirstUnverifiedPayments(() => {
        window.scrollTo({
          top: this.component.props.app?.financePaymentsListPosition
        });
      });
    });
  }
}

export default new PaymentsWillMount();
